import React, { useState, useEffect, useRef } from 'react';
import Breadcrumbs from '../../components/common/Breadcrumbs/Breadcrumbs';
import YouTubeOAuth from '../../components/main/Landing/YouTubeOAuth';
import { useDispatch } from 'react-redux';
import { storeYoutubeAuth } from '../../store/BusinessStore/actions/InfluencerChannelActions/storeYoutubeAuthActions';
import { youtube_redirect_uri, youtube_redirect_uri_auth_only } from '../../store/constants';
import { useToast } from "../../hooks/useToast";
import {
    storeValidateChannel
} from "../../store/BusinessStore/actions/InfluencerChannelActions/storeValidateChannelActions";
import { FaCircleCheck } from "react-icons/fa6";
import Popup from "../../components/popups/Popup/Popup";
import { useNavigate } from "react-router";
import { getUserInfo } from "../../store/authStore/actions/authActions/getUserInfoActions";
import { useSelector } from "react-redux";

function InfluencerChannelAuthOnly() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [platform, setPlatform] = useState("");
    const [errors, setErrors] = useState({});
    const [channelList, setChannelList] = useState([
    ]);

    const youtubeAccountAccessType = useSelector((state) => state.utilReducers.youtubeAccountAccessType);
    // Guards to avoid double-dispatch (e.g., StrictMode) and simultaneous calls
    const hasDispatchedAuthRef = useRef(false);
    const effectOnceRef = useRef(false);

    const breadcrumbData = [
        { label: 'Home', href: '/' },
        { label: 'My Channel', href: '/influencer/my-channels' },
    ];

    const Toast = useToast();
    console.log("youtubeAccountAccessType : ", youtubeAccountAccessType)
    const handleStoreYoutubeAuth = (authCode) => {
        if (hasDispatchedAuthRef.current) return;
        hasDispatchedAuthRef.current = true;
        dispatch(storeYoutubeAuth({
            "googleCode": authCode,
            "redirectUri": youtube_redirect_uri_auth_only,
            "channelAccessType": youtubeAccountAccessType,
            "platform": 'YOUTUBE',
            "tokenExpiredSecond": "",
            "shortLivedToken": "",
            "longLivedToken": "",
        }, (status, response, message) => {
            if (status === 200) {
                console.log("Calling getUserInfo from InfluencerChannelAuthOnly")
                dispatch(getUserInfo((status, response, message) => {
                    if (status === 200) {
                        window.close()
                        console.log("closing window from InfluencerChannelAuthOnly")
                    } else {
                        Toast(message, 'error');
                    }
                }))
            } else if (status) {
                Toast(message, 'error');
                // allow retry if needed after an error
                hasDispatchedAuthRef.current = false;
            }
        }));
    };

    useEffect(() => {
        if (effectOnceRef.current) return;
        effectOnceRef.current = true;
        dispatch(getUserInfo());
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        console.log("youtube code", code)
        if (code) {
            handleStoreYoutubeAuth(code);
            // Clean up query params to avoid reusing the same code
            try {
                const url = new URL(window.location.href);
                url.searchParams.delete('code');
                url.searchParams.delete('scope');
                url.searchParams.delete('state');
                window.history.replaceState({}, document.title, url.pathname + (url.search ? `?${url.searchParams.toString()}` : '') + url.hash);
            } catch (e) {}
        }
    }, []); // Run once on component mount

    return (
        <div className='w-full flex flex-col overflow-auto bg-[#F2F3F7]'>
            <Breadcrumbs breadcrumbs={breadcrumbData} />
            <div className='p-[4rem] min-h-[70rem] relative'>
                <h2 className="text-[#534D4D] text-[1.8rem] font-[600]">Select the Platform</h2>
                <div className="flex justify-between items-end mt-[1.5rem]">
                    <div className="w-[49%]">
                        <label className="text-[1.6rem] inter-font font-[400] text-[#111729]">
                            Platform
                            <span className="text-red-500">*</span>
                        </label>
                        <select
                            className="w-full px-4 py-4 mt-[.8rem] text-[1.6rem] inter-font font-[400] border border-[#E3E8EF] rounded-lg focus:outline-none"
                            value={platform}
                            onChange={(e) => {
                                setPlatform(e.target.value);
                                setErrors((prevState) => { const { ["platform"]: _, ...updatedObject } = prevState; return updatedObject; });
                            }}
                        >
                            <option value="" disabled>Select Platform</option>
                            <option value="YOUTUBE">YOUTUBE</option>
                            <option value="INSTAGRAM">INSTAGRAM</option>
                            <option value="TIKTOK" disabled>TikTok (coming soon)</option>
                        </select>
                        {errors.platform && (
                            <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                                {errors.platform}
                            </p>
                        )}
                    </div>
                    {platform ? 
                        // <YouTubeOAuth redirectUri={youtube_redirect_uri_auth_only} /> 
                        <button
                            className="w-[21rem] px-4 py-[1rem] text-[2rem] rounded-[1.2rem] cursor-pointer bg-[#0D9B50] text-white hover:bg-[#0D9B50]/90"
                            onClick={() => {
                                navigate(`/influencer/choose-access-type?platform=${platform}`)
                            }}
                        >
                            Connect to Channel
                        </button>
                        : 
                        null
                    }

                </div>
            </div>

        </div>
    );
}

export default InfluencerChannelAuthOnly;
